
import React from 'react';
import { Box, TextField } from '@mui/material';
import { isRTL } from '../generalUtils';

const YouSaid = ({ value , lang}) => {

    return (
        <Box sx={{ 
                    // maxWidth: 350, 
                    ml: 1, mr:1, mt:0, mb:1}}>
            <TextField
                title="This is how your speech has been understood by AI"
                label="You said:"
                value={value}
                multiline
                fullWidth
                minRows = {2}
                // rows={2} // stabilizes the size to avoid ResizeObserver loop warning
                maxRows={4} // Allow expansion to a limited number of rows
                variant="outlined"
                slotProps={{
                    input: {
                        readOnly: true,
                        dir: isRTL(lang) ? 'rtl' : 'ltr',
                        style: { textAlign: isRTL(lang) ? 'right' : 'left' }
                    },
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderColor: 'blue',
                    },
                }}
            />

        </Box>
    );
};

export default YouSaid;
